<template>
  <v-card rounded="lg" height="100%" min-height="140">
    <v-card-title
      class="justify-center pt-2 pa-2 v-card__title"
      style="color: var(--v-btntext-base);"
    >{{ title }}</v-card-title>
    <v-card-text class="text-card-value py-5" :style="styleObject">
      <img :src="coinImg">
      {{ value % 1 > 0 ? v_comma(value.toFixed(1)) : v_comma(value) }} 원
    </v-card-text>
    <v-card-text class="text-card-unit" v-if="unit">{{ unit }}</v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'TextCard',
  data() {
    return {
      coinImg: require('@/assets/image/monitoring/icon_coin.png')
    }
  },
  props: {
    title: String,
    value: {
      type: Number,
      default: 0
    },
    unit: {
      type: String
    },
    color: String
  },
  computed: {
    styleObject() {
      return { color: this.color }
    }
  },
  methods: {
    v_comma(r) {
      return r.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      // return r.toString()
    }
  }
}
</script>

<style scoped>
.text-card-value {
  font-size: 40px;
  font-weight: bold;
  text-align: center;
}

.text-card-unit {
  font-size: 14px;
  font-weight: lighter;
  color: #999;
  text-align: center;
}
.v-card__title {
  font-size: 1.16rem !important;
}
</style>
